angular.module('impactx.login')
    .controller('CopyCCUserController', ['LoginService', 'cookieService', '$mdDialog', '$listCache', '$scope', 'AppConfiguration', CopyCCUserController]);

function CopyCCUserController(LoginService, cookieService, $mdDialog, $listCache, $scope, AppConfiguration) {
    var self = this;
    cookieService.removeCookie("loginPage");

    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    this.logout = function () {
        LoginService.logout();
    };

    this.redirectToCopyCCUser = function () {
        $listCache.removeAll();
        $mdDialog.hide();

        $mdDialog.show({
            templateUrl: './modules/login/templates/copyccuser.html',
            controller: 'CopyCCUserDialogController',
            controllerAs: "copyCCUserCtrl",
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        });
    };

    this.redirectToCopyCCUser();
}